export default __webpack_public_path__ + "4ef98184d9542298fd5d3a4c628efb50.jpg";